import React from "react";
import { PropTypes } from "prop-types";
import { themes } from "../../theme";

const ExchangeTicketsIcon = ({ children, color, ...props }) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
  >
    {children}
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1.000000, -1.000000)">
        <rect x="1" y="1" width="24" height="24" />
        <path
          fill={color}
          {...color !== "currentColor" && { fillOpacity: ".65" }}
          fillRule="nonzero"
          d="M2.70710678,9 L13.5,9 C13.7761424,9 14,9.22385763 14,9.5 C14,9.77614237 13.7761424,10 13.5,10 L2.70710678,10 L4.85355339,12.1464466 C5.04881554,12.3417088 5.04881554,12.6582912 4.85355339,12.8535534 C4.65829124,13.0488155 4.34170876,13.0488155 4.14644661,12.8535534 L1.14644661,9.85355339 C0.951184464,9.65829124 0.951184464,9.34170876 1.14644661,9.14644661 L4.14644661,6.14644661 C4.34170876,5.95118446 4.65829124,5.95118446 4.85355339,6.14644661 C5.04881554,6.34170876 5.04881554,6.65829124 4.85355339,6.85355339 L2.70710678,9 Z M18.2928932,4 L16.1464466,1.85355339 C15.9511845,1.65829124 15.9511845,1.34170876 16.1464466,1.14644661 C16.3417088,0.951184464 16.6582912,0.951184464 16.8535534,1.14644661 L19.8535534,4.14644661 C20.0488155,4.34170876 20.0488155,4.65829124 19.8535534,4.85355339 L16.8535534,7.85355339 C16.6582912,8.04881554 16.3417088,8.04881554 16.1464466,7.85355339 C15.9511845,7.65829124 15.9511845,7.34170876 16.1464466,7.14644661 L18.2928932,5 L7.5,5 C7.22385763,5 7,4.77614237 7,4.5 C7,4.22385763 7.22385763,4 7.5,4 L18.2928932,4 Z M19.9601551,18.131728 L15.7175144,13.8890873 L10.0606602,19.5459415 L14.3033009,23.7885822 L19.9601551,18.131728 Z M20.6672619,17.4246212 L22.7885822,15.3033009 L21.9393066,14.4540252 C21.230958,14.6195402 20.4809901,14.4099223 19.9601551,13.8890873 C19.4393201,13.3682523 19.2297022,12.6182844 19.3952172,11.9099358 L18.5459415,11.0606602 L16.4246212,13.1819805 L20.6672619,17.4246212 Z M13.9497475,24.8492424 L9,19.8994949 C8.80473785,19.7042328 8.80473785,19.3876503 9,19.1923882 L18.1923882,10 C18.3876503,9.80473785 18.7042328,9.80473785 18.8994949,10 L20.3137085,11.4142136 C20.4476246,11.5481297 20.4943859,11.7462135 20.4344968,11.9258808 L20.3971711,12.0378577 C20.263255,12.4396061 20.3678163,12.8825349 20.6672619,13.1819805 C20.9667075,13.4814261 21.4096363,13.5859874 21.8113847,13.4520713 L21.9233616,13.4147456 C22.1030289,13.3548565 22.3011127,13.4016178 22.4350288,13.5355339 L23.8492424,14.9497475 C24.0445046,15.1450096 24.0445046,15.4615921 23.8492424,15.6568542 L14.6568542,24.8492424 C14.4615921,25.0445046 14.1450096,25.0445046 13.9497475,24.8492424 Z"
        />
      </g>
    </g>
  </svg>
);

ExchangeTicketsIcon.displayName = "ExchangeTicketsIcon";

ExchangeTicketsIcon.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string
};

ExchangeTicketsIcon.defaultProps = {
  children: null,
  color: themes.global.gray01
};

export default ExchangeTicketsIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/ExchangeTickets.js